import src from "IMAGE";
export default { src, width: 3300, height: 524, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mMQEzWdJiigVc7Gxq/Fziaox84moMvOLmgAwmxsAtoAREUDeSk4tsYAAAAASUVORK5CYII="};
